<template>
  <b-modal
    :id="modalName"
    :title="title"
    centered
    hide-footer
    size="sm"
    :no-close-on-backdrop="true"
    @hidden="resetModal"
  >
    <b-form @submit.prevent="submit">
      <b-form-group label="Name" label-for="name">
        <b-form-input
          id="name"
          v-model="fields.name"
          v-validate="{ required: true }"
          type="text"
          placeholder="Name"
          data-vv-name="Name"
          size="lg"
        ></b-form-input>
      </b-form-group>

      <b-form-group label="Category" label-for="category">
        <multiselect
          v-model="fields.category"
          v-validate="{ required: true }"
          :options="validFilters"
          :taggable="true"
          label="name"
          placeholder="Select category"
          tag-placeholder="Create new category"
          open-direction="bottom"
          data-vv-name="category"
          @input="categoryChanged"
          @tag="createCategory"
        ></multiselect>
      </b-form-group>

      <b-form-group label="Subcategory" label-for="subcategory">
        <multiselect
          v-model="fields.subcategory"
          v-validate="{ required: true }"
          :options="selectedCategoryFilters"
          :taggable="true"
          label="name"
          placeholder="Select subcategory"
          tag-placeholder="Create new subcategory"
          open-direction="bottom"
          data-vv-name="subcategory"
          @tag="createSubCategory"
        ></multiselect>
      </b-form-group>

      <b-form-checkbox v-model="fields.visibility.discover" size="sm" class="mb-4" switch
        >Discover Visibility</b-form-checkbox
      >

      <b-row>
        <b-col class="text-right">
          <b-btn variant="primary" type="submit">Save</b-btn>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import _ from "lodash";
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";
import DataSettings from "@/helpers/DataSettings";

export default {
  name: "FilterItemModal",
  components: {
    Multiselect
  },
  props: {
    create: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    filter: {
      type: Array,
      required: false,
      default: null
    },
    newfilter: {
      type: [String, Object, Array], // TODO: Check allowed types
      required: false,
      default: null
    }
  },
  data() {
    return {
      fields: {
        name: null,
        category: null,
        subcategory: null,
        visibility: {
          'all': true,
          'discover': true
        }
      }
    };
  },
  computed: {
    ...mapState({
      filters: state => state.filter.filters,
      discoverCategories: (state) => state.setting.dataSettings.focus.lastQuery,
    }),
    modalName() {
      return "modal-filter-" + (this.create ? "create" : "edit");
    },
    validFilters(){
      return this.filters.filter(c => c.name !== 'tempmaincat' && !c.name.includes("_del"));
    },
    selectedCategoryFilters() {
      if (!this.filters || !this.fields.category) {
        return [];
      }

      return this.fields.category.children.filter(c => !c.name.includes("_del"));
    }
  },
  watch: {
    filter(val) {
      this.fields.name = val.name;
      //this.fields.category = val.category;
      //this.fields.subcategory = val.subcategory;
      _.each(this.filters, cat => {
        _.each(cat.children, subcat => {
          let contains = _.findIndex(subcat.children, f => f._id === val._id);
          if (contains > -1) {
            this.fields.category = cat;
            this.fields.subcategory = subcat;
            this.fields.visibility.discover = this.visibleForDiscover(val._id);
            /*const cindex = _.findIndex(this.discoverCategories, f => f._id === cat._id);
            const sindex = _.findIndex(this.discoverCategories[cindex].children, f => f._id === subcat._id);
            const index = _.findIndex(this.discoverCategories[cindex].children[sindex].children, f => f._id === val._id);
            this.fields.visibility.discover = 
              this.discoverCategories[cindex].children[sindex].children[index].visibility?
              this.discoverCategories[cindex].children[sindex].children[index].visibility.discover 
              : true;
            */
          }
        });
      });
    }
  },
  methods: {
    ...mapActions(["saveFilter"]),
    categoryChanged() {
      if (
        !this.fields.category ||
        !this.fields.subcategory ||
        !this.fields.subcategory.parent_id
      ) {
        this.fields.subcategory = null;
        return;
      }

      if (this.fields.category._id !== this.fields.subcategory.parent_id) {
        this.fields.subcategory = null;
      }
    },
    createCategory(e) {
      this.fields.category = { name: e };
    },
    createSubCategory(e) {
      this.fields.subcategory = { name: e };
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return false;
        }

        let payloadFilter;
        if (this.newfilter) {
          if(this.filter._id.includes("invalid") || (this.filter.id && this.filter.id.includes("imp"))){
            payloadFilter = {
              name: this.filter.name,
              type: "filter",
              query: Array.isArray(this.newfilter)
                ? this.newfilter
                : [this.newfilter]
            };
          }
          else{
            payloadFilter = {
              _id: this.filter._id,
              updated_date: "updated_date" in this.filter? this.filter.updated_date: null,
              name: this.fields.name,
              type: "filter",
              //visibility: this.fields.visibility,
              query: Array.isArray(this.newfilter)
                ? this.newfilter
                : [this.newfilter]
            };
          }
        } else {
          payloadFilter = {
            name: this.fields.name,
            type: "filter",
            query: [
              // TODO: Pass selected annotations
              {
                _id: "yr_0",
                name: "1963",
                url: "",
                type: "Year"
              }
            ]
          };
        }
        let payloadCategory = {};
        if (this.fields.category._id) {
          payloadCategory._id = this.fields.category._id;
        } else {
          payloadCategory.name = this.fields.category.name;
        }

        let payloadSubcategory = {};
        if (this.fields.subcategory._id) {
          payloadSubcategory._id = this.fields.subcategory._id;
        } else {
          payloadSubcategory.name = this.fields.subcategory.name;
        }

        this.saveFilter({
          filter: payloadFilter,
          category: payloadCategory,
          subcategory: payloadSubcategory
        }).then((res) => {
          if(res.message === "Timestamp miss match"){
            this.$bvModal.hide(this.modalName);
            this.$toasted.show("Filter could not be updated. A newer version found!", {Type: "Error"});
            this.$emit("handleMisMatched", payloadCategory._id);
          }
          else{
            //console.log(res);
            this.updateVisibility(res);
            /*
            this.updateVisibility({
              filter: payloadFilter,
              category: payloadCategory,
              subcategory: payloadSubcategory
            });
            */
            this.$emit("clearBuilder");
            this.$bvModal.hide(this.modalName);
            this.$toasted.show("Filter updated");
          }
        });
      });
    },
    visibleForDiscover(filt){
      if(this.discoverCategories.length > 0){
        return !this.discoverCategories.includes(filt)
      }
      else{
        return true
      }
    },
    updateVisibility(data){
      const settings = DataSettings.getSettings("focus");
      if(!this.fields.visibility.discover){
        if(!settings.lastQuery.includes(data._id)){
          let newSettings = settings.lastQuery;
          newSettings.push(data._id);
          DataSettings.setSettings("focus.lastQuery", newSettings);
        }
      }
      else{
        if(settings.lastQuery.includes(data._id)){
          let newSettings = settings.lastQuery;
          const index = _.findIndex(newSettings, data._id);
          newSettings.splice(index, 1);
          DataSettings.setSettings("focus.lastQuery", newSettings);
        }
      }
      /*
      const filter = data.filter;
      const category = data.category;
      const subcategory = data.subcategory;
      const settings = DataSettings.getSettings("focus");
      let discoverCats = settings.lastQuery || this.filters;
      let cindex = _.findIndex(discoverCats, (f) => { return f._id === category._id; });
      let sindex = _.findIndex(discoverCats[cindex].children, (f) => { return f._id === subcategory._id; });
      let index = _.findIndex(discoverCats[cindex].children[sindex].children, (f) => { return f._id === filter._id; });
      let newSettings = discoverCats;
      newSettings[cindex].children[sindex].children[index].visibility = this.fields.visibility;
      DataSettings.setSettings("focus.lastQuery", newSettings);
      */
    },
    resetModal(){
      console.log("reset modal");
      this.$emit("clearBuilder");
      this.fields = {
        name: null,
        category: null,
        subcategory: null,
        visibility: {
          'all': true,
          'discover': false
        }
      }
    }
  }
};
</script>
